module.exports = __webpack_public_path__ + "static/media/web.1397cbc7.png";